var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "view-all-tenancies-component-tenants" } },
    [
      _c("sticky", [
        _c("div", { staticClass: "clearfix header-panel" }, [
          _c("div", { staticClass: "header" }, [
            _c("span", { staticClass: "notice-header" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$i18n.t("tenancy.viewAll.title")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "right-btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.resetFilters()
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("action.resetFilter")) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { id: "query-btn", type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.queryTenancyRecords()
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("action.search")) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tenancy-table" },
        [
          _c(
            "div",
            { staticStyle: { display: "inline", "vertical-align": "middle" } },
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("total")) + ": " + _vm._s(_vm.displayListLength)
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("CommonTable", {
            ref: "tenant-tenancy-record-table",
            attrs: {
              tableId: "tenant-tenancy-record-table",
              renderHeaderList: _vm.itemHeaders,
              tableContentLists: _vm.parsedTenancyRecords,
              needSearch: true,
              defaultOrder: true,
              defaultOrderKey: _vm.defaultOrderKey,
              yScrollAuto: false,
              minWidth1800px: false,
              getDisplayListLength: _vm.getDisplayListLength,
              getConditions: _vm.getConditions,
              enterEvent: _vm.queryTenancyRecords,
              interactionFunc: _vm.interactionFunc,
              orderMethods: _vm.orderMethods,
              getTableOrder: _vm.getTableOrder,
              orderByDateKeys: ["goExpiredDate"],
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }